export default __webpack_public_path__ + "static/media/lifan.beabfdc6.png";